<div class="d-flex justify-content-between align-items-center mb-3 sticky-header">
  <div>
    <h4 class="mb-0">
      {{ 'Settings::WorkEnvironment:DeclineReasons:Title' | abpLocalization }}
    </h4>
    <p class="text-muted small mb-0 mt-1">
      {{ 'Settings::WorkEnvironment:DeclineReasons:Subtitle' | abpLocalization }}
    </p>
  </div>
  <button type="button" class="btn btn-primary btn-sm" (click)="openAddDialog()">
    <i class="pi pi-plus me-2"></i>
    {{ 'Settings::WorkEnvironment:DeclineReasons:AddReason' | abpLocalization }}
  </button>
</div>

<app-decline-reason-list
  [reloadVersion]="reloadVersion"
  (edit)="openEditDialog($event)"
  (deleted)="onDeleted()" />

<app-decline-reason-form-dialog
  [visible]="showDialog"
  [reasonId]="selectedReasonId"
  (visibleChange)="onDialogVisibilityChange($event)"
  (saved)="onSaved()" />
